import styled, { css } from 'styled-components';
import { getTextTokenPresetObject, IconButton } from '@optimus-web/core';
import { ANIMATION_DURATION, getSpacingToken, getToken } from '@optimus-web/common';
import { HEIGHT_APP_NAV_BAR } from '../../../components/commander-ui/constants';

export const SideBarIconButton = styled(IconButton)<{ hide?: boolean }>`
    ${({ hide }) =>
        hide &&
        css`
            display: none;
        `}
`;

export const LogoWrapper = styled.a`
    text-decoration: none;
    display: inline-flex;
    color: ${getToken('textStaticOnColor')};
    fill: ${getToken('textStaticOnColor')};
    &:visited,
    &:hover,
    &:active,
    &:focus {
        text-decoration: none;
        color: ${getToken('textStaticOnColor')};
        fill: ${getToken('textStaticOnColor')};
    }
`;

export const SearchBarWrapper = styled.div`
    width: 100%;
    padding-left: ${getSpacingToken('200')}px;

    ${(props) =>
        (props as $TSFixMe).isMobileOrTablet &&
        css`
            position: absolute;
            left: 0;
            width: 100%;
            height: ${HEIGHT_APP_NAV_BAR};
            background: ${getToken('backgroundStaticSunken')};
            transition: all;
            opacity: 0;
            z-index: 10;
            padding: ${getSpacingToken('0')} ${getSpacingToken('200')}px;
            top: -${HEIGHT_APP_NAV_BAR};
            transform: translate(0, 0);
            transition-duration: ${ANIMATION_DURATION.default}ms;
        `}

    ${(props) =>
        (props as $TSFixMe).opened &&
        css`
            transform: translate(0, 100%);
            opacity: 1;
        `}
`;

export const SeparatorElement = styled.span`
    border-left: ${getToken('borderWidth150')}px solid ${getToken('borderStaticPrimary')};
    height: 18px;
`;

export const PlatformBadgeElement = styled.span`
    display: inline-block;
    text-transform: uppercase;
    background: ${getToken('backgroundInteractivePrimaryDefault')};
    color: ${getToken('textStaticOnColor')};
    font-weight: ${(props) => getTextTokenPresetObject('titleSmallStrong')({ theme: props.theme }).fontWeight};
    padding: ${getSpacingToken('0')} ${getSpacingToken('100')}px;
    border-radius: ${getToken('borderRadius25')}px;
    margin-left: ${getSpacingToken('100')}px;
    cursor: pointer;
`;
